import React from 'react';
import { ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon } from '@heroicons/react/24/outline';
import Button from '../../Button';
import { useTranslation } from 'react-i18next';

interface INavButton {
  first: boolean;
  last: boolean;
  setIndex: any;
}
export default function NavButton({ first, last, setIndex }: INavButton) {
  const { t } = useTranslation(['client']);

  return (
    <span className="inline-flex space-x-2">
      {!first ? (
        <Button
        type="button"
        onClick={() => {
          setIndex({ type: 'navigate', payload: { direction: -1 } });
        }}
        leftIcon={<ArrowLeftIcon
          className="h-6 w-6  mr-1"
          aria-hidden="true"
        />}
      >
        Question précédente
      </Button>
      ) : (
        ''
      )}
      {!last ? (
        <Button
        type="button"
        rightIcon={<ArrowRightIcon
          className="h-6 w-6  ml-1"
          aria-hidden="true"
        />}
        onClick={() => {
          setIndex({ type: 'navigate', payload: { direction: 1 } });
        }}
      >
        Question suivante
      </Button>
      ) : (
        ''
      )}
    </span>
  );
}
